module.exports = __webpack_public_path__ + "img/background.c6e35698.jpg";